import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  UncontrolledTooltip,
} from 'reactstrap';

import { Localization } from 'react-widgets';
import { GithubPicker } from 'react-color';
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter, selectFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';
import momentLocalizer from 'react-widgets-moment';
import Moment from 'moment';
import FileSaver from 'file-saver';
import DataEmptyState from '../../../../../commons/dataemptystate';
import QueryEmptyState from '../../../../../commons/queryempty';
import NetworkEmptyState from '../../../../../commons/networkemptystate';
import Loader from '../../../../../commons/loader';
import Services from '../services';
import { PaginationTotal, DatetimePicker } from '../../../../../commons/controls';
import { ProgressButton } from '../../../../../commons/ProgressButton';
import Lib from '../../../../../commons/lib';
import getTooltip from './LeltarTooltips';
import CustomTooltip from '../../../../../components/Tooltip/CustomTooltip';

import 'moment/locale/hu';
import RFForm from '../../../../../components/Form/RFForm';
import TimeFormatter from '../../../../../commons/TimeFormatter';

// momentLocalizer(Moment);
Moment.locale('hu');
const localizer = new momentLocalizer(Moment);

class LeltarLista extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // ['QUERY', 'LOAD', 'DATA', 'NETW', 'TABL']
      tableLeltarStatus: 'QUERY',
      // ['LOAD', 'DATA', 'NETW']
      formStatus: 'DATA',
      // ['FEL', 'MOD']
      formType: 'FEL',
      // DATA
      baseJson: [],
      leltarIvJson: [],
      expanded: [],
      currentId: undefined,
      torlesId: undefined,
      // MODAL UTILS
      modalForm: false,
      modalDelete: false,
      modalKorrekcio: false,
      saveButtonLoading: false,
      deleteButtonLoading: false,
      keresesButtonLoading: false,
      // FORM VALUES
      formFordulonap: TimeFormatter.formatDate(Moment()),
      formNev: '',
      formAzonosito: '',
      formSzinkod: '',
      formAkadalymentesitett: false,
      formHasznalhato: true,

      pdfButtonLoading: false,
    };

  }

  componentDidMount() {
    this.listLeltar(true);
  }

  // componentDidUpdate(prevProps) {
  //   // Typical usage (don't forget to compare props):
  //   if (this.props.active !== prevProps.active) {
  //     if (this.props.active == 6) {
  //       this.listAllapot();
  //     }
  //   }
  // }

  toggleFormModal = () => {
    this.setState(prevState => ({ modalForm: !prevState.modalForm }));
  }

  toggleDeleteModal = () => {
    this.setState(prevState => ({ modalDelete: !prevState.modalDelete }));
  }

  toggleVeglegezesModal = () => {
    this.setState(prevState => ({ modalVeglegezes: !prevState.modalVeglegezes }));
  }

  toggleKorrekcioModal = () => {
    this.setState(prevState => ({ modalKorrekcio: !prevState.modalKorrekcio }));
  }

  listLeltar = (firstQuery) => {
    this.setState({
      tableLeltarStatus: 'LOAD',
      tableLeltarIvStatus: undefined,
      keresesButtonLoading: true,
      expanded: []
    }, () => {
      let minDate = new Date();
      Services.listLeltar({ forduloNap: firstQuery ? null : this.state.formFordulonap }, (err, res) => {
        if (!err) {
          let formatedJson = [];
          res[0].forEach((leltar) => {
            if (firstQuery && new Date(minDate) >= new Date(leltar.forduloDatum))
              minDate = leltar.forduloDatum;
            if (leltar.leltarKezdete) {
              leltar.kezdetevege = TimeFormatter.formatDateTime(leltar.leltarKezdete) + ' - ';
              if (leltar.leltarVege)
                leltar.kezdetevege += TimeFormatter.formatDateTime(leltar.leltarVege);
            }
            leltar.fordulonap = TimeFormatter.formatDateTimeWithoutSeconds(leltar.forduloDatum);
            formatedJson.push(leltar);
          });
          this.setState({
            tableLeltarStatus: formatedJson.length > 0 ? 'TABL' : 'DATA',
            baseJson: formatedJson,
            keresesButtonLoading: false,
          });
          if (firstQuery)
            this.setState({ 
              formFordulonap: TimeFormatter.formatDate(minDate),
              keresesButtonLoading: false, 
            });
        } else {
          this.setState({
            tableLeltarStatus: 'NETW',
            keresesButtonLoading: false,
          });
        }
      });
    });
  }

  getAllapot = (id) => {
    this.setState({
      formStatus: 'LOAD'
    });
    Services.getAllapot(id, (err, res) => {
      if (!err) {
        this.setState({
          formStatus: 'DATA',

          formNev: this.nullToString(res[0].nev),
          formAzonosito: this.nullToString(res[0].azonosito),
          formSzinkod: this.nullToString(res[0].szin),
        });
      } else {
        this.setState({
          formStatus: 'NETW'
        });
      }
    });
  }

  handleInputChange = (e) => {
    const { target } = e;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    this.setState({
      [name]: value
    });
  }

  handleDateInputChange = (e, v, name) => {
    const value = v === '' ? null : v;
    this.setState({
      [name]: value
    });
  }

  //   handleDateInputChange = (e, v, name) => {
  //   const value = v === '' ? null : v;
  //   this.setState({
  //     [name]: value
  //   });
  // }

  handleColorChange = (color) => {
    this.setState({ formSzinkod: color.hex.substr(1, 6) });
  }

  // handleEditClick = (cell) => {
  //   this.setState({
  //     formType: 'MOD',
  //     currentId: cell,
  //     modalForm: true
  //   }, () => {
  //     this.getAllapot(cell);
  //   });
  // }

  handleDeleteClick = (cell) => {
    this.setState({
      torlesId: cell
    }, () => {
      this.toggleDeleteModal();
    });
  }

  handleVeglegezesClick = (cell) => {
    this.setState({
      veglegezesId: cell
    }, () => {
      this.toggleVeglegezesModal();
    });
  }

  handleKorrekcioClick = (cell) => {
    this.setState({
      korrekcioId: cell
    }, () => {
      this.toggleKorrekcioModal();
    });
  }

  getLeltarPdf = (id, type) => {
    this.setState({ pdfButtonLoading: true, });
    Services.getLeltarPdf(id, type, (err, res) => {
      if (!err) {
        const pdf = new Blob([res[0]], { type: 'application/pdf' })
        const fileURL = URL.createObjectURL(pdf);
        window.open(fileURL, '_blank');
      }
      this.setState({ pdfButtonLoading: false, });
    });
  }

  getLeltarivPdf = (id, type) => {
    this.setState({ pdfButtonLoading: true, });
    Services.getLeltarivPdf(id, type, (err, res) => {
      if (!err) {
        const pdf = new Blob([res[0]], { type: 'application/pdf' })
        const fileURL = URL.createObjectURL(pdf);
        window.open(fileURL, '_blank');
      }
      this.setState({ pdfButtonLoading: false, });
    });
  }

  deleteLeltar = () => {
    this.setState({
      deleteButtonLoading: true
    });
    Services.deleteLeltar(this.state.torlesId, (err) => {
      if (!err) {
        this.toggleDeleteModal();
        this.listLeltar();
        this.props.globals.addSuccess('Leltár törölve!');
        this.setState({
          deleteButtonLoading: false
        });
      } else {
        this.setState({
          deleteButtonLoading: false
        });
      }
    });
  }

  veglegezes = () => {
    this.setState({
      veglegezesButtonLoading: true
    });
    Services.acceptLeltar(this.state.veglegezesId, (err) => {
      if (!err) {
        this.toggleVeglegezesModal();
        this.listLeltar();
        this.props.globals.addSuccess('A leltár véglegezve lett!');
        this.setState({
          veglegezesButtonLoading: false
        });
      } else {
        this.setState({
          veglegezesButtonLoading: false
        });
      }
    });
  }

  korrekcio = () => {
    this.setState({
      korrekcioButtonLoading: true
    });
    Services.getLeltarKorrekcio(this.state.korrekcioId, (err) => {
      if (!err) {
        this.toggleKorrekcioModal();
        this.listLeltar();
        this.props.globals.addSuccess('A korrekció végrehajtásra került!');
        this.setState({
          korrekcioButtonLoading: false
        });
      } else {
        this.setState({
          korrekcioButtonLoading: false
        });
      }
    });
  }

  handleCikkekClick = (id) => {
    if (!this.state.expanded.includes(id)) {
      this.setState(() => ({
        expanded: [...this.state.expanded, id]
      }));
    } else {
      this.setState(() => ({
        expanded: this.state.expanded.filter(x => x !== id)
      }));
    }
  }

  emptyOrNull = (data) => {
    if (!data || data === '') return null;
    return data;
  }

  nullToString = (data) => {
    if (!data) return '';
    return data;
  }

  handleNewClick = () => {
    this.props.globals.route.navigate({
      pathname: process.env.PUBLIC_URL + '/admin/keszlet/keszletkezeles/leltar/felvetel',
    });
  }

  handleEditClick = (id) => {
    this.props.globals.route.navigate({
      pathname: process.env.PUBLIC_URL + '/admin/keszlet/keszletkezeles/leltar/modositas',
      search: '?id=' + id,
    });
  }

  hasLeltarKarb = () => {
    return this.props.globals.hasRole(['KESZLETNYILV_LELTAR'], true);
  }

  tableIconFormatter = (cell, row) => {
    return (
      <div>
        <React.Fragment>
          {(this.hasLeltarKarb() || this.props.globals.hasRoleSpec(['KESZLETNYILV_LELTAR_KORREKCIO'])) && (row.leltarAllapotEnum.name === 'JOVAHAGYAS' || row.leltarAllapotEnum.name === 'LEZART') && (
            <React.Fragment>
              <ProgressButton loading={this.state.pdfButtonLoading} className="table-action-icon" id={'action-pdf-' + cell + 'jegyzokonyv'} onClick={() => this.getLeltarPdf(cell, 'JEGYZOKONYV')}>
                <i class="fa fa-file-pdf-o" />
              </ProgressButton>
              <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-pdf-' + cell + 'jegyzokonyv'} delay={50}>
                {'Jegyzőkönyv'}
              </UncontrolledTooltip>
            </React.Fragment>
          )}
          {this.props.globals.hasRoleSpec(['KESZLETNYILV_LELTAR_VEGLEGEZES']) && row.leltarAllapotEnum.name === 'FOLYAMATBAN' && (
            <React.Fragment>
              <Button className="table-action-icon" id={'action-view-' + cell + 'korrekcio'} onClick={() => this.handleVeglegezesClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }}>
                <i class="fa fa-check-square-o" />
              </Button>
              <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'korrekcio'} delay={50}>
                {'Véglegezés'}
              </UncontrolledTooltip>
            </React.Fragment>
          )}
          {this.props.globals.hasRoleSpec(['KESZLETNYILV_LELTAR_KORREKCIO']) && row.leltarAllapotEnum.name === 'JOVAHAGYAS' && (
            <React.Fragment>
              <Button className="table-action-icon" id={'action-view-' + cell + 'korrekcio'} onClick={() => this.handleKorrekcioClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }}>
                <i class="fa fa-files-o" />
              </Button>
              <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'korrekcio'} delay={50}>
                {'Korrekció'}
              </UncontrolledTooltip>
            </React.Fragment>
          )}
          {row.leltarAllapotEnum.name !== 'LEZART' && (
            <React.Fragment>
              {((this.hasLeltarKarb() || this.props.globals.hasRoleSpec(['KESZLETNYILV_LELTAR_MENNYROGZ'])) && row.leltarAllapotEnum.name === 'FOLYAMATBAN') && (
                <React.Fragment>
                  <Button className="icon-pencil table-action-icon" id={'action-view-' + cell + 'modositas'} onClick={() => this.handleEditClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
                  <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'modositas'} delay={50}>
                    {'Módosítás'}
                  </UncontrolledTooltip>
                </React.Fragment>
              )}
            </React.Fragment>
          )}
          {(this.hasLeltarKarb() || this.props.globals.hasRoleSpec(['KESZLETNYILV_LELTAR_KORREKCIO'])) && (row.leltarAllapotEnum.name === 'JOVAHAGYAS' || row.leltarAllapotEnum.name === 'FOLYAMATBAN') && (
            <React.Fragment>
              <Button className="icon-trash table-action-icon" id={'action-delete-' + cell} onClick={() => this.handleDeleteClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
              <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-delete-' + cell} delay={50}>
                {'Törlés'}
              </UncontrolledTooltip>
            </React.Fragment>
          )}
        </React.Fragment>
      </div>
    );
  }

  tableBooleanFormatter = (cell) => {
    return cell
      ? <span className="badge badge-success">Igen</span>
      : <span className="badge badge-default">Nem</span>;
  }

  styleSzinkod = (szinkod) => {
    return {
      textAlign: 'center',
      whiteSpace: 'pre-line',
      backgroundColor: '#' + szinkod,
      color: this.getCorrectTextColor('#' + szinkod)
    };
  }

  renderFormTitle = () => {
    switch (this.state.formType) {
      case 'FEL':
        return 'Új leltár létrehozása';
      case 'MOD':
        return 'Leltár módosítása';
      default:
        return '';
    }
  }

  listLeltarIv = (leltarid) => {
    this.setState({
      currentLeltarId: leltarid,
      tableLeltarIvStatus: 'LOAD'
    }, () => {
      Services.listLeltarIv({ leltarId: leltarid }, (err, res) => {
        if (!err) {
          let formatedJson = [];
          res[0].forEach((leltarIv) => {
            formatedJson.push(leltarIv);
          });
          this.setState({
            tableLeltarIvStatus: formatedJson.length > 0 ? 'TABL' : 'DATA',
            leltarIvJson: formatedJson,
          });
        } else {
          this.setState({
            tableLeltarIvStatus: 'NETW'
          });
        }
      });
    });
  }

  onRowSelect = (row, isSelected, e) => {
    this.listLeltarIv(row.id);
  }

  renderTable = () => {
    const options = {
      sizePerPage: 25,
      showTotal: true,
      paginationTotalRenderer: PaginationTotal,
      sizePerPageList: [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
        { text: '25', value: 25 }
      ],
    };

    const selectRow = {
      mode: 'radio',
      // clickToSelect: true,
      onSelect: this.onRowSelect,
      // style: { background: 'red' }
    };

    const selectOptions = {
      true: 'Igen',
      false: 'Nem',
    };

    const columns = [
      {
        dataField: 'kezdetevege',
        text: 'Leltár kezdete-vége',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line',
        },
        sort: true,
        headerFormatter: (column, colIndex, components) => (
          <>
            {column.text}
            {components.sortElement}
            <CustomTooltip text={getTooltip('kezdetvege')} id="kezdetvegeTT" />
            {components.filterElement}
          </>
        ),
      },
      {
        dataField: 'fordulonap',
        text: 'Fordulónap',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
        },
        sort: true,
        headerFormatter: (column, colIndex, components) => (
          <>
            {column.text}
            {components.sortElement}
            <CustomTooltip text={getTooltip('fordulonaptable')} id="fordulonaptableTT" />
            {components.filterElement}
          </>
        ),
      },
      {
        dataField: 'erintettRaktarak',
        text: 'Érintett raktárak',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line',
        },
        sort: true
      },
      {
        dataField: 'mod.caption',
        text: 'Leltározás módja',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
        },
        sort: true,
        headerFormatter: (column, colIndex, components) => (
          <>
            {column.text}
            {components.sortElement}
            <CustomTooltip text={getTooltip('leltarmod')} id="leltarmodTT" />
            {components.filterElement}
          </>
        ),
      },
      {
        dataField: 'keszlet_blokk',
        align: 'center',
        text: 'Forgalom blokkolása',
        filter: selectFilter({
          options: selectOptions,
          placeholder: 'Összes',
        }),
        style: {
          whiteSpace: 'pre-line'
        },
        sort: true,
        formatter: this.tableBooleanFormatter,
        headerFormatter: (column, colIndex, components) => (
          <>
            {column.text}
            {components.sortElement}
            <CustomTooltip text={getTooltip('forgalomblokk')} id="forgalomblokkTT" />
            {components.filterElement}
          </>
        ),
      },
      {
        dataField: 'bizonylat.bizonylatszam',
        text: 'Bizonylatszám',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
        },
        sort: true
      },
      {
        dataField: 'leltarAllapotEnum.caption',
        text: 'Állapot',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
        },
        sort: true,
        headerFormatter: (column, colIndex, components) => (
          <>
            {column.text}
            {components.sortElement}
            <CustomTooltip text={getTooltip('allapot')} id="allapotTT" />
            {components.filterElement}
          </>
        ),
      },
      {
        dataField: 'korrekcioInfo',
        text: 'Korrekciót végezte',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line',
        },
        sort: true
      },
      {
        dataField: 'id',
        text: 'Műveletek',
        formatter: this.tableIconFormatter
      }
    ];

    return (
      <div className="animated fadeIn">
        <div className="col-md-12" style={{ paddingLeft: 0 }}>
          <h4>Leltár: </h4>
        </div>
        <BootstrapTable
          bootstrap4
          keyField="id"
          data={this.state.baseJson}
          columns={columns}
          wrapperClasses="table-responsive"
          classes="table-scroll"
          headerClasses="table-th"
          filter={filterFactory()}
          selectRow={selectRow}
          pagination={paginationFactory(Lib.bootstraptableProps)}
          noDataIndication="Nincs megjelenítendő adat!"
        />
      </div>
    );
  }

  szemelyFormatter = (cell, row) => {
    if (!cell) {
      return row.szemelyNev;
    }

    return cell;
  }

  leltarIvFormatter = (cell, row) => {
    return (
      <div>
        {
          <React.Fragment>
            <React.Fragment>
              <Button className="table-action-icon" id={'action-view-' + cell + 'cikk'} onClick={() => this.handleCikkekClick(cell)}>
                <i class="fa fa-list" />
              </Button>
              <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'cikk'} delay={50}>
                {'Cikkek'}
              </UncontrolledTooltip>
            </React.Fragment>
            {this.props.globals.hasRole(['KESZLETNYILV_LELTAR'], false) && (this.hasLeltarKarb() || this.props.globals.hasRoleSpec(['KESZLETNYILV_LELTAR_KORREKCIO']) || this.props.globals.hasRoleSpec(['KESZLETNYILV_LELTAR_VEGLEGEZES'])) && (
              <>
                <ProgressButton loading={this.state.pdfButtonLoading} className="table-action-icon" id={'action-pdf-' + cell + 'elteres'} onClick={() => this.getLeltarivPdf(cell, 'ELTERES')}>
                  <i class="fa fa-file-pdf-o" />
                </ProgressButton>
                <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-pdf-' + cell + 'elteres'} delay={50}>
                  {'Eltérés PDF'}
                </UncontrolledTooltip>
              </>
            )}
            {this.hasLeltarKarb() && (  
              <>
                <ProgressButton loading={this.state.pdfButtonLoading} className="table-action-icon" id={'action-pdf-' + cell + 'felveteli'} onClick={() => this.getLeltarivPdf(cell, 'FELVETELI_IV')}>
                  <i class="fa fa-file-pdf-o" />
                </ProgressButton>
                <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-pdf-' + cell + 'felveteli'} delay={50}>
                  {'Felvételi iv PDF'}
                </UncontrolledTooltip>
              </>
            )}
          </React.Fragment>
      }
      </div>
    );
  }

  renderLeltarIvTable = () => {
    const options = {
      sizePerPage: 25,
      showTotal: true,
      paginationTotalRenderer: PaginationTotal,
      sizePerPageList: [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
        { text: '25', value: 50 }
      ],
    };

    const optionsCikk = {
      sizePerPage: 50,
      showTotal: true,
      paginationTotalRenderer: PaginationTotal,
      sizePerPageList: [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
        { text: '50', value: 50 }
      ],
    };

    const columns = [
      {
        dataField: 'bizonylat.bizonylatszam',
        text: 'Bizonylatszám',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line'
        },
        sort: true
      },
      {
        dataField: 'raktar.nev',
        text: 'Raktár',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line'
        },
        sort: true
      },
      {
        dataField: 'szemely.nev',
        text: 'Felelős',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line'
        },
        sort: true,
        formatter: this.szemelyFormatter
      },
      {
        dataField: 'uvd.rogzszemelynev',
        text: 'Rögzítő személy',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line'
        },
        sort: true,
      },
      {
        dataField: 'rogzidopont',
        text: 'Rögzítési időpont',
        style: {
          whiteSpace: 'pre-line'
        },
        sort: true,
        formatter: rogzidopont => rogzidopont && TimeFormatter.format(rogzidopont, "YYYY.MM.DD HH:mm:ss")
      },
      {
        dataField: 'id',
        text: 'Műveletek',
        formatter: this.leltarIvFormatter
      }
    ];

    const childColumns = [
      {
        dataField: 'cikk.cikkszam',
        text: 'Cikkszám',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line'
        },
        sort: true,
        editable: false
      },
      {
        dataField: 'cikk.megnevezes',
        text: 'Megnevezés',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line'
        },
        sort: true,
        editable: false
      },
      {
        dataField: 'cikk.mennyisegiEgyseg',
        text: 'Mennyiségi egység',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line'
        },
        align: 'center',
        editable: false
      },
      {
        dataField: 'leltarMennyiseg',
        text: 'Leltározott mennyiség',
        // filter: textFilter({
        //   delay: 400, // default is 500ms
        //   placeholder: 'Keresés...',
        // }),
        // style: {
        //   whiteSpace: 'pre-line'
        // }
        align: 'right',
        editable: false,
      },
      {
        dataField: 'modUserNev',
        text: 'Módosító személy',
      },
      {
        dataField: 'id',
        text: 'Műveletek',
        hidden: true
      }
    ];

    const mennyisegCol = {
      dataField: 'eredetiMennyiseg',
      text: 'Mennyiség',
      filter: textFilter({
        delay: 400, // default is 500ms
        placeholder: 'Keresés...',
      }),
      style: {
        whiteSpace: 'pre-line'
      },
      align: 'right',
      editable: false,
      headerFormatter: (column, colIndex, components) => (
        <>
          {column.text}
          {components.sortElement}
          <CustomTooltip text={getTooltip('cikkmennyiseg')} id="cikkmennyisegTT" />
          {components.filterElement}
        </>
      ),
    };

    let childColumnsExpanded = [...childColumns];
    childColumnsExpanded.splice(3, 0, mennyisegCol);

    const expandRow = {
      renderer: row => (row.leltarIvCikkEntityList
        ? (
          <React.Fragment>
            <h5>Cikkek:</h5>
            <BootstrapTable
              bootstrap4
              keyField="id"
              data={row.leltarIvCikkEntityList}
              columns={row.withmennyiseg ? childColumnsExpanded : childColumns}
              filter={filterFactory()}
              pagination={paginationFactory(Lib.bootstraptableProps)}
              noDataIndication="Nincs megjelenítendő adat!"
            />
          </React.Fragment>
        )
        : null
      ),
      expanded: this.state.expanded,
      expandByColumnOnly: true
    };

    return (
      <div className="animated fadeIn">
        <div className="col-md-12" style={{ paddingLeft: 0 }}>
          <h4>Leltárív: </h4>
        </div>
        <BootstrapTable
          bootstrap4
          keyField="id"
          data={this.state.leltarIvJson}
          columns={columns}
          filter={filterFactory()}
          pagination={paginationFactory(Lib.bootstraptableProps)}
          expandRow={expandRow}
          noDataIndication="Nincs megjelenítendő adat!"
        />
      </div>
    );
  }

  render() {
    const {
      formFordulonap
    } = this.state;

    return (
      <Localization date={localizer}>
        <React.Fragment>
          <RFForm onSubmit={() => {}}>
            <div className="row">
              <div className="col-md-3">
                <DatetimePicker
                  label={'Fordulónap (-tól):'}
                  tooltip={<CustomTooltip text={getTooltip('fordulonap')} id="fordulonapTT" />}
                  containerClassName="organw-date-time"
                  // format="YYYY-MM-DD"
                  time={false}
                  messages={{ dateButton: 'dátum', timeButton: 'idő' }}
                  onChange={(e, v) => this.handleDateInputChange(e, v, 'formFordulonap')}
                  value={formFordulonap && new Date(formFordulonap)}
                  name="formFordulonap"
                  id="formFordulonap"
                />
              </div>
              <div className="col-md-3">
                <ProgressButton className="pull-left table-new-button" color="success" onClick={() => { this.listLeltar(); }} loading={this.state.keresesButtonLoading} style={{ marginTop: 28 }}>
                  {'Keresés'}
                </ProgressButton>
              </div>
            </div>
          </RFForm>
          <div className="row">
            {this.hasLeltarKarb() && (
              <div className="col-md-12">
                <Button className="pull-left table-new-button" color="primary" onClick={this.handleNewClick}>
                  {'Új leltár'}
                </Button>
              </div>
            )}
            <div className="col-md-12">
              {{
                QUERY: (<QueryEmptyState
                  hasImage
                />),
                LOAD: (<Loader />),
                DATA: (<DataEmptyState
                  hasImage
                  subtitle="Vigyél fel új tételt!"
                />),
                NETW: (<NetworkEmptyState
                  hasImage
                  submitClick={() => { this.listLeltar(); }}
                />),
                TABL: (this.renderTable())
              }[this.state.tableLeltarStatus]}
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              {{
                QUERY: (<QueryEmptyState
                  hasImage
                />),
                LOAD: (<Loader />),
                DATA: (<DataEmptyState
                  hasImage
                  subtitle="Vigyél fel új tételt!"
                />),
                NETW: (<NetworkEmptyState
                  hasImage
                  submitClick={() => { this.listLeltarIv(this.state.currentLeltarId); }}
                />),
                TABL: (this.renderLeltarIvTable())
              }[this.state.tableLeltarIvStatus]}
            </div>
          </div>
          <Modal isOpen={this.state.modalDelete} toggle={this.toggleDeleteModal} backdrop="static">
            <ModalHeader>Törlés</ModalHeader>
            <ModalBody>Valóban törölni kívánod a kiválasztott tételt?</ModalBody>
            <ModalFooter>
              <ProgressButton
                className="btn-cursor-pointer"
                color="primary"
                onClick={() => this.deleteLeltar()}
                loading={this.state.deleteButtonLoading}
              >
                {'Igen'}
              </ProgressButton>
              <Button type="button" color="secondary" onClick={this.toggleDeleteModal}>Mégsem</Button>
            </ModalFooter>
          </Modal>
          <Modal isOpen={this.state.modalVeglegezes} toggle={this.toggleVeglegezesModal} backdrop="static">
            <ModalHeader>Véglegezés</ModalHeader>
            <ModalBody>Biztosan véglegezni szeretnéd a leltárt?</ModalBody>
            <ModalFooter>
              <ProgressButton
                className="btn-cursor-pointer"
                color="primary"
                onClick={() => this.veglegezes()}
                loading={this.state.veglegezesButtonLoading}
              >
                {'Igen'}
              </ProgressButton>
              <Button type="button" color="secondary" onClick={this.toggleVeglegezesModal}>Mégsem</Button>
            </ModalFooter>
          </Modal>
          <Modal isOpen={this.state.modalKorrekcio} toggle={this.toggleKorrekcioModal} backdrop="static">
            <ModalHeader>Korrekció</ModalHeader>
            <ModalBody>Biztosan végrehajtja a készlet korrekciót? A korrekcióval automatikusan létrehozásra kerülnek a többlet, és hiánynak megfelelő készletnövekedési és készletcsökkenési tételek!</ModalBody>
            <ModalFooter>
              <ProgressButton
                className="btn-cursor-pointer"
                color="primary"
                onClick={() => this.korrekcio()}
                loading={this.state.korrekcioButtonLoading}
              >
                {'Igen'}
              </ProgressButton>
              <Button type="button" color="secondary" onClick={this.toggleKorrekcioModal}>Mégsem</Button>
            </ModalFooter>
          </Modal>
        </React.Fragment>
      </Localization>
    );
  }
}

LeltarLista.propTypes = {
  active: PropTypes.bool,
  globals: PropTypes.object
};

export default LeltarLista;
